export default {
    title: "Merge clients",
    description: "Which field do you want to use to merge clients?",
    fieldExternalId: "Integration ID",
    fieldEmail: "Email",
    fieldWhatsapp: "Phone",
    previewButton: "Preview",
    previewTitle: "Preview",
    clientsColumn: "Clients",
    nameLabel: "Name",
    emailLabel: "Email",
    whatsappLabel: "WhatsApp",
    mergeButton: "Merge",
    selectFieldAlert: "Select a field to merge clients",
    mergeSuccessAlert: "Clients merged successfully",
};
